"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const useQCurrency_1 = __importDefault(require("components/QCurrency/useQCurrency"));
const ValueText = styled_components_1.default.span `display: inline; text-align: center; color: black;`;
const ValueField = (props) => {
    const { inputValue, color, type, noBrackets, keepCents } = props;
    const { formatAmount } = (0, useQCurrency_1.default)();
    const value = inputValue === null || Number.isNaN(inputValue) ? 'N/A' : inputValue;
    const isPercentage = type === 'percentage';
    const percent = isPercentage ? '%' : '';
    const needsBrackets = noBrackets !== 'true';
    const showCents = keepCents !== undefined ? !keepCents : true;
    const lb = (isPercentage && needsBrackets) ? '(' : '';
    const rb = (isPercentage && needsBrackets) ? ')' : '';
    let valueFormatted;
    if (type === 'number') {
        valueFormatted = formatAmount(value, null, showCents);
    }
    else if (isPercentage) {
        valueFormatted = formatAmount(value, null);
    }
    else {
        valueFormatted = formatAmount(value, 'USD');
    }
    if (value === 'N/A') {
        return (type === 'percentage'
            ? (<div />)
            : (<ValueText>&nbsp;{value}</ValueText>));
    }
    let theColor = color || 'black';
    if (color === 'sign') {
        if (value === 0) {
            theColor = 'black';
        }
        else if (value < 0) {
            theColor = 'red';
        }
        else {
            theColor = 'green';
        }
    }
    return (<ValueText style={{ color: theColor }}>
      &nbsp;{lb}{valueFormatted}{percent}{rb}
    </ValueText>);
};
exports.default = ValueField;
